/**
 * Document title while a change (card) is open.
 * Keeps the browser tab starting with the slug, and prevents ActiveTrack
 * from overwriting it every second.
 */

let openChangeTitle: string | null = null;
let previousTitle: string | null = null;

export function formatChangeDocumentTitle(slugName: string, cardTitle?: string): string {
    const title = (cardTitle || '').trim();
    return title ? `${slugName} — ${title}` : slugName;
}

export function getOpenChangeDocumentTitle(): string | null {
    return openChangeTitle;
}

export function setOpenChangeDocumentTitle(title: string | null): void {
    if (!title) {
        clearOpenChangeDocumentTitle();
        return;
    }
    if (openChangeTitle === null)
        previousTitle = document.title;
    openChangeTitle = title;
    document.title = title;
}

export function clearOpenChangeDocumentTitle(): void {
    const restore = previousTitle;
    openChangeTitle = null;
    previousTitle = null;
    if (restore != null)
        document.title = restore;
}

/** Apply the active-track title, unless a change view owns the tab title. */
export function applyActiveTrackDocumentTitle(duration: string, trackTitle: string): void {
    if (openChangeTitle) {
        document.title = openChangeTitle;
        return;
    }
    document.title = `${duration} - ${trackTitle}`;
}
